import { getCategories } from "@/api/filters"
export default {
  state: {
    data: {
      placeholder: "Categories",
      trackBy: "id",
      options: []
    },
    icons: {
      1: "hologram",
      2: "screen",
      3: "video-projector",
      4: "led-belt",
      5: "led-belt"
    }
  },
  mutations: {
    GET_CATEGORIES: (state, categories) => {
      state.data.options = categories
    }
  },
  actions: {
    async getCategories({ commit }) {
      try {
        const response = await getCategories()
        commit("GET_CATEGORIES", response)
      } catch (err) {
        throw new Error("Couldn't get supports:\n", err)
      }
    }
  }
}
